module.exports = __webpack_public_path__ + "static/media/button_up_clicked.b17d8005.svg";